<script>
import CardUpdatableFooterConfirm from '@/components/partials/CardUpdatableFooterConfirm.vue';

export default {
   name: 'CardUpdatableFooterOneUpdate',
   mixins: [CardUpdatableFooterConfirm],

   data: function () {
      return {
      }
   },

   methods: {

      async update_row(row) {
         console.log('CardUpdatableFooterOneUpdate::update_row');
         if ( this.level.callbacks.update_row ) {
            console.log('CardUpdatableFooterOneUpdate::update_row, un callback existe');
            var { errorinfos, api_response } = await this.level.callbacks.update_row(this.$router,this.level.api_code,row._pk,row);
            console.log('CardUpdatableFooterOneUpdate::update_row, affichage errors');
            if ( this.level.callbacks.refresh_errors ) {
               this.level.callbacks.refresh_errors(this.level.level,[errorinfos]);
            }
         } else {
            console.log('CardUpdatableFooterOneUpdate::update_row, pas de callback.');
            var { errorinfos, api_response } = await this.$api.updateRow(this.$router,this.level.api_code,row._pk, row);
         }
         console.log('CardUpdatableFooterOneUpdate::update_row, NATIF, AFTER AWAIT, api_response='+JSON.stringify(api_response));
         if ( api_response.error==0 ) {
            this.level.callbacks.show_dialog(this.level.level,false);
         } else {
            console.log('update_row, ELSE affichage errors');
            // ERRORS !
            if ( this.level.callbacks.refresh_errors ) {
               this.level.callbacks.refresh_errors(this.level.level,[errorinfos]);
            }
         }
      },

   },
  
}
</script>